import type { PublishedAttributeGroupingUnformatted } from './types';
import { PublishedAttributeOwnerType } from './types';

export const PII_CHECKBOX_LABEL = 'This attribute contains '
  + 'Personally Identifiable Information (PII)';

export const PII_CHECKBOX_HELP_TEXT = 'Marks this attribute as containing PII and ensures it is '
  + 'protected accordingly. Values are hashed when building '
  + 'rules; only exact string matching is supported.';

export const PUBLISHED_ATTRIBUTE_OBJECT_TYPE_LABELS: Record<string, string> = {
  entity: 'Entity',
  session: 'Session',
  transaction: 'Transaction',
  bank_account: 'Bank Account',
};

export const OUTPUT_CATEGORY_RISK_SCORING = 'Risk Scoring';
export const OUTPUT_CATEGORY_SESSION_RISK_SCORING = 'Session Risk Scoring';

// Stable key for the watchlist-disposition system PA category, sent to Typhon via
// GET /published-attributes?sysPACategories to surface these PAs in the workflow editor.
export const WATCHLIST_DISPOSITION_PA_CATEGORY_KEY = 'watchlist-disposition';

export const mockPublishedAttributes = [
  {
    published_attribute_token: 'PA-foo',
    published_attribute_name: 'foo',
    data_type: 'integer',
    default_value: 100,
    default_value_note: 'One hondo',
    description: 'Description',
    value_expires_in: 86400,
    contains_pii: false,
    jq_filter: null,
    archived: false,
    active_workflows: [],
    object_type: 'entity',
    owner_type: PublishedAttributeOwnerType.CLIENT,
    service_name: 'service',
    _embedded: {
      grouping: {
        grouping_token: 'PAG-123',
      },
    },
  },
  {
    published_attribute_token: 'PA-bar',
    published_attribute_name: 'bar',
    data_type: 'integer',
    default_value: 100,
    default_value_note: 'One hondo',
    description: 'Description',
    value_expires_in: 86400,
    contains_pii: false,
    jq_filter: null,
    archived: true,
    active_workflows: [],
    object_type: 'entity',
    owner_type: PublishedAttributeOwnerType.CLIENT,
    service_name: 'service',
    _embedded: {
      grouping: {
        grouping_token: 'PAG-123',
      },
    },
  },
  {
    published_attribute_token: 'PA-baz',
    published_attribute_name: 'baz',
    data_type: 'string',
    default_value: 'test',
    default_value_note: null,
    description: 'Transaction attribute',
    value_expires_in: 86400,
    contains_pii: false,
    jq_filter: null,
    archived: false,
    active_workflows: [],
    object_type: 'transaction',
    owner_type: PublishedAttributeOwnerType.CLIENT,
    service_name: 'service',
    _embedded: {
      grouping: null,
    },
  },
];

export const mockGroupings: PublishedAttributeGroupingUnformatted[] = [
  {
    grouping_token: 'PAG-123',
    name: 'Grouping Name 2',
    archived: false,
    created_at: 150068082389,
    order: 1,
    _embedded: {
      published_attributes: [
        {
          published_attribute_token: 'PA-foo',
          name: 'foo',
        },
        {
          published_attribute_token: 'PA-bar',
          name: 'bar',
        },
      ],
    },
  },
  {
    grouping_token: 'PAG-345',
    name: 'Grouping Name 3',
    archived: true,
    created_at: 150068083389,
    order: 2,
    _embedded: {
      published_attributes: [],
    },
  },
];

export const PublishedAttributesPermissionMessages = {
  CANNOT_CREATE: "You don't have permission to create Published Attributes",
  CANNOT_EDIT: "You don't have permission to edit Published Attributes",
  CANNOT_EDIT_SYSTEM: "You don't have permission to edit System Published Attributes",
};

export const outputCategoryOptions = [
  { label: OUTPUT_CATEGORY_RISK_SCORING, value: OUTPUT_CATEGORY_RISK_SCORING },
  { label: OUTPUT_CATEGORY_SESSION_RISK_SCORING, value: OUTPUT_CATEGORY_SESSION_RISK_SCORING },
];
